import styled, { css } from 'styled-components';
import { isValidValue } from '../../methods/common.js';
import { convertHexToRGBA } from '../../methods/convertHexToRGBA.js';
import COLORS from '../../constants/colors.js';
import FONTS from '../../constants/fonts.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';

const hZSpacing = "12px";
const vTSpacing = "12px";
const inputCommonSpace = css `
    padding: ${vTSpacing} 0px;
`;
const affixInitialStyle = css `
    display: none;
    line-height: 18px;
    font-size: inherit;
    color: ${COLORS.GREY_400};
    cursor: inherit;
`;
const InputAffixWrapper = styled.span `
    ${({ children }) => (children ? inputCommonSpace : ``)};
    ${affixInitialStyle}
`;
const inputAffixVisibleStyle = css `
    ${InputAffixWrapper} {
        display: inline-flex;
    }
`;
const InputPrefixWrapper = styled(InputAffixWrapper) `
    padding: 0 ${hZSpacing};
`;
const InputSuffixWrapper = styled(InputAffixWrapper) `
    padding: 0 ${hZSpacing};
`;
const InputLabel = styled.span `
    ${inputCommonSpace}
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: 0.5s ease all;
    pointer-events: none;
    color: ${COLORS.GREY_600};
`;
const floatingLabelUnderlineInput = css `
    font-size: 13px;
    top: 0;
    left: 0;
`;
const inputUnderlineStyle = css `
    border-bottom: 2px solid ${COLORS.GREY_300};
    background-color: transparent;

    ${InputLabel} {
        ${({ filled }) => (filled ? floatingLabelUnderlineInput : ``)}
    }
    &:focus-within ${InputLabel} {
        ${floatingLabelUnderlineInput}
    }
`;
const floatingLabelBorderInput = css `
    color: ${COLORS.BLUE};
    background-color: ${COLORS.WHITE};
    font-size: 13px;
    border-radius: 2px;
    /* box-shadow: 2px 2px 2px 2px ${convertHexToRGBA(COLORS.GREY_1000, 0.2)}; */
    top: 0;
    left: 5px;
    padding: 0 1em;
    padding-top: 2px;
`;
const getBorderColorAccordingToState = (state) => {
    switch (state) {
        case "success":
            return COLORS.GREEN_600;
        case "error":
            return COLORS.RED;
    }
};
// border: 2px solid ${COLORS.GREY_200};
const inputBorderStyle = css `
    border-radius: 3px;
    border: ${({ borderSize }) => `${borderSize ? borderSize : 2}px solid ${COLORS.GREY_200}`};
    ${({ state }) => state
    ? css `
                  border-color: ${getBorderColorAccordingToState(state)} !important;
              `
    : null}
    background-color: ${COLORS.WHITE};
    padding: 0 20px;

    ${InputLabel} {
        ${({ filled }) => (filled ? floatingLabelBorderInput : ``)}
    }
    &:focus-within ${InputLabel} {
        ${floatingLabelBorderInput}
    }
`;
const InputWrapper = styled.div `
    display: flex;
    align-items: center;
    position: relative;
    cursor: text;
    ${({ outline }) => {
    switch (outline) {
        case "underline":
            return inputUnderlineStyle;
        case "border":
            return inputBorderStyle;
    }
}}
    &:focus-within {
        border-color: ${COLORS.BLUE};
    }
    ${inputAffixVisibleStyle}
    ${({ disabled }) => disabled
    ? css `
                  background-color: ${COLORS.GREY_100};
                  cursor: not-allowed;
              `
    : null}
`;
const StyledInput = styled.input `
    ${inputCommonSpace}
    font-size: 18px;
    width: 100%;
    outline: none;
    border: none;
    background-color: inherit;
    line-height: 100%;
    font-family: ${({ weight }) => weight && FONTS[weight.toUpperCase()]};

    &::placeholder {
        opacity: ${({ label }) => (isValidValue(label) ? 0 : 1)};
        color: ${COLORS.GREY_400};
        font-family: ${FONTS.REGULAR};
        font-size: 13px;
        line-height: 18px;
        vertical-align: middle;
    }

    &:disabled {
        cursor: not-allowed;
    }

    &:disabled {
        cursor: not-allowed;
    }

    &[type="number"]::-webkit-inner-spin-button,
    &[type="number"]::-webkit-outer-spin-button {
        appearance: none;
    }
    &:disabled {
        cursor: not-allowed;
    }
`;

export { InputAffixWrapper, InputLabel, InputPrefixWrapper, InputSuffixWrapper, InputWrapper, StyledInput };
//# sourceMappingURL=Input.styles.js.map
